const common = {
  brand: "USFansSheet",
  nav: {
    home: "Inicio",
    shopGuide: "Guía de compras",
    categories: "Categorías",
    resources: "Recursos",
    guides: "Guías",
    safety: "Seguridad",
    faq: "Preguntas frecuentes",
  },
  languages: {
    en: "English",
    pl: "Polski",
    es: "Español",
    fr: "Français",
  },
  footer: {
    tagline: "Un centro de recursos independiente para investigación, guías y consejos de seguridad sobre la hoja de cálculo de USFans.",
    navTitle: "Explorar",
    categoriesTitle: "Categorías",
    disclaimer: "USFansSheet.live es un recurso informativo independiente. No está necesariamente afiliado a, operado por ni respaldado por USFans. La información puede cambiar y debe verificarse de forma independiente antes de realizar compras, pagos o decisiones sobre cuentas.",
    rights: "Todos los derechos reservados.",
  },
};

export default common;